(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("chevrotain"));
	else if(typeof define === 'function' && define.amd)
		define("HyperFormula", ["chevrotain"], factory);
	else if(typeof exports === 'object')
		exports["HyperFormula"] = factory(require("chevrotain"));
	else
		root["HyperFormula"] = factory(root["chevrotain"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__165__) {
return 